// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Datasource constants and metadata.
 */

import type { DatasourceType } from './types'

/**
 * All available datasource types.
 */
export const DATASOURCE_TYPES: DatasourceType[] = [
  'maryland_bill_master_list',
  'full_text',
  'original_document',
  'optix_documents',
  'analysis_results',
]

/**
 * Human-readable labels for datasource types.
 */
export const DATASOURCE_LABELS: Record<DatasourceType, string> = {
  maryland_bill_master_list: 'Maryland Bill Master List',
  full_text: 'Full Text',
  original_document: 'Original Document',
  optix_documents: 'Optix Documents',
  analysis_results: 'Analysis Results',
}

/**
 * Descriptions for datasource types.
 */
export const DATASOURCE_DESCRIPTIONS: Record<DatasourceType, string> = {
  maryland_bill_master_list: 'List bills from Maryland General Assembly API',
  full_text: 'Extracted text from workspace documents for analysis',
  original_document: 'Original document files from workspace storage',
  optix_documents: 'Fetch I-9 documents from Optix document management system',
  analysis_results: 'Existing analysis outputs from DynamoDB/S3',
}
